const annual_revenue = [
  { id: 0, key: '0_100k', label: '$0 to $100k' },
  { id: 1, key: '100k_250k', label: '$100k to $250k' },
  { id: 2, key: '250k_500k', label: '$250k to $500k' },
  { id: 3, key: '500k_1m', label: '$500k to $1M' },
  { id: 4, key: '1m_2.5m', label: '$1M to $2.5M' },
  { id: 5, key: '2.5m_5m', label: '$2.5M to $5M' },
  { id: 6, key: '5m_10m', label: '$5M to $10M' },
  { id: 7, key: '10m_more', label: 'Over $10M' },
  { id: 8, key: 'undisclosed', label: 'Undisclosed' },
]
export default annual_revenue
